import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const handleAddBodyClass = () => {
    document.body.classList.add("search-open");
  };
  const handleRemoveBodyClass = () => {
    document.body.classList.remove("search-open");
  };

  return (
    <>
      <div className="flyout-menu">
        <div className="fmenu-contaner">
          <div className="site-logo">
            <a href="https://agweb.co.in/"> fashion Hub </a>
          </div>
          <div className="mobile-toggle">
            <button className="hamburger-cls">
              <span className="cl-line" />
              <span className="cl-line" />
            </button>
          </div>
          <div className="fly-menu">
            <div className="pd-20">
              <ul className="main-list">
                <li>
                  <a href="#">$20 BLOWOUT SALE </a>
                </li>
                <li>
                  <Link to="/new-arrivals">Just Arrived </Link>
                  <ul>
                    <li>
                      <Link to="/new-arrivals">RESTOCKS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW TOPS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW SWEATERS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW DRESSES</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW BOTTOMS</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/new-arrivals">SHOP BY CATEGORY</Link>
                  <ul>
                    <li>
                      <Link to="/new-arrivals">RESTOCKS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW TOPS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW SWEATERS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW DRESSES</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW BOTTOMS</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/new-arrivals">Chelsea Freeman Collection</Link>
                  <ul>
                    <li>
                      <Link to="/new-arrivals">RESTOCKS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW TOPS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW SWEATERS</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW DRESSES</Link>
                    </li>
                    <li>
                      <Link to="/new-arrivals">NEW BOTTOMS</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/new-arrivals">CLOTHING</Link>
                </li>
                <li>
                  <Link to="/new-arrivals">SHOP DRESSES</Link>
                </li>
                <li>
                  <Link to="/new-arrivals">ACCESSORIES</Link>
                </li>
                <li>
                  <Link to="/new-arrivals">More</Link>
                  <ul>
                    <li>
                      <Link to="/location">Locations</Link>
                    </li>
                    <li>
                      <Link to="/faqs">In-Store Perks </Link>
                    </li>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <a href="instructions.html">Instructions About theme</a>
                    </li>
                    <li>
                      <a href="#">Help support</a>
                    </li>
                    <li>
                      <a href="#">Carrer </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/*flyout-menu*/}

      <header className="header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="user-nav">
                <ul className="list-style mb-0">
                  <li>
                    <Link to="/login">
                      <span className="mbri-login" /> Sign in
                    </Link>
                  </li>
                  <li>
                    <Link to="/register">
                      {" "}
                      <span className="mbri-edit" /> Register
                    </Link>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="serach-btn"
                      onClick={handleAddBodyClass}
                    >
                      {" "}
                      <span className="mbri-search" />
                      Search
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-6">
              <div className="site-logo text-center">
                <Link to="/">
                  <img
                    src="neerthreadlogo.jpg"
                    alt="logo"
                    style={{ maxWidth: "10%" }}
                  />
                </Link>
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-6">
              <div className="cart-nav text-right">
                <ul className="list-style mb-0">
                  <li>
                    <Link to="/gift-coupon">
                      <span className="mbri-gift" />
                    </Link>
                  </li>
                  <li>
                    <Link to="/cart">
                      <span className="mbri-shopping-bag">
                        <sup className="fs-13">03</sup>
                      </span>
                    </Link>
                    <ul>
                      <li>
                        <div className="cart-item">
                          <div className="cart-item-img">
                            <a href="#">
                              <img
                                src="images/white-top-with-jacket.jpg"
                                alt="jacket"
                              />
                            </a>
                          </div>
                          <div className="cart-item-info">
                            <div className="prd-info">
                              <h4 className="prd-name">
                                <a href="#" tabIndex={0}>
                                  Astronet Cotton Blended Regular Tops -
                                  <span className="prd-color">Black</span>
                                </a>
                              </h4>
                              <div className="prices">
                                <span>$30</span>{" "}
                                <del className="tcolor">$70</del>
                              </div>
                              <button className="sm-btn">Delete</button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="cart-item">
                          <div className="cart-item-img">
                            <a href="#">
                              <img src="images/kasmiri.jpg" alt="jacket" />
                            </a>
                          </div>
                          <div className="cart-item-info">
                            <div className="prd-info">
                              <h4 className="prd-name">
                                <a href="#" tabIndex={0}>
                                  Astronet Cotton Blended Regular Tops -
                                  <span className="prd-color">Black</span>
                                </a>
                              </h4>
                              <div className="prices">
                                <span>$130</span>{" "}
                                <del className="tcolor">$70</del>
                              </div>
                              <button className="sm-btn">Delete</button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="cart-item">
                          <div className="cart-item-img">
                            <a href="#">
                              <img src="images/whiteshut.jpg" alt="jacket" />
                            </a>
                          </div>
                          <div className="cart-item-info">
                            <div className="prd-info">
                              <h4 className="prd-name">
                                <a href="#" tabIndex={0}>
                                  Astronet Cotton Blended Regular Tops -
                                  <span className="prd-color">Black</span>
                                </a>
                              </h4>
                              <div className="prices">
                                <span>$30</span>{" "}
                                <del className="tcolor">$70</del>
                              </div>
                              <button className="sm-btn">Delete</button>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li></li>
                      <li>
                        <div className="cart-item">
                          <p className="total-amount">
                            Total <span>$190</span>
                          </p>
                          <p className="total-amount">
                            Discount <span>$230</span>
                          </p>
                          <Link to="/checkout" className="sm-btn btn">
                            Checkout
                          </Link>
                        </div>
                      </li>
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    <button className="store-pin">
                      <span className="mbri-map-pin" /> SET YOUR STORE
                      <small>View pricing &amp; availability</small>
                    </button>
                    <ul>
                      <li>
                        <div className="store-search text-left">
                          <h6>Select a Store</h6>
                          <p className="fs-13">
                            <span className="material-icons">location_on</span>
                            <Link to="/location">Use my current location</Link>
                          </p>
                          <form>
                            <input
                              type="text"
                              name="zip"
                              placeholder="Enter zipcode or state"
                              className="form-control"
                            />
                          </form>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <button className="menu-hamburger">
                  <span className="menu-button-line" />
                  <span className="menu-button-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="main-header border-top">
          <nav className="nav">
            <ul className="list-style mb-0 main-list">
              <li>
                <a href="#">$20 BLOWOUT SALE </a>
              </li>
              <li className="mega-menu">
                <Link to="/new-arrivals"> Just Arrived </Link>
                <ul>
                  <li>
                    <div className="container">
                      <ul>
                        <li>
                          <a href="#">All Just Arrived </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">SHOP BY CATEGORY</a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">Chelsea Freeman Collection </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li className="mega-menu">
                <a href="#">CLOTHING</a>
                <ul>
                  <li>
                    <div className="container">
                      <ul>
                        <li>
                          <a href="#">All Just Arrived </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">SHOP BY CATEGORY</a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">Chelsea Freeman Collection </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li className="mega-menu">
                <a href="#">SHOP DRESSES</a>
                <ul>
                  <li>
                    <div className="container">
                      <ul>
                        <li>
                          <a href="#">All Just Arrived </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">SHOP BY CATEGORY</a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">Chelsea Freeman Collection </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li className="mega-menu">
                <a href="#">ACCESSORIES</a>
                <ul>
                  <li>
                    <div className="container">
                      <ul>
                        <li>
                          <a href="#">All Just Arrived </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">SHOP BY CATEGORY</a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="#">Chelsea Freeman Collection </a>
                          <ul>
                            <li>
                              <a href="#">RESTOCKS </a>
                            </li>
                            <li>
                              <a href="#">NEW TOPS </a>
                            </li>
                            <li>
                              <a href="#">NEW SWEATERS </a>
                            </li>
                            <li>
                              <a href="#">NEW DRESSES </a>
                            </li>
                            <li>
                              <a href="#">NEW BOTTOMS </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
              <li className="mega-menu">
                <a href="#">More </a>
                <ul>
                  <li>
                    <div className="container">
                      <ul>
                        <li>
                          <Link to="/locations">Locations </Link>
                        </li>
                        <li>
                          <a href="#">In-Store Perks </a>
                          <ul>
                            <li>
                              <Link to="/about-us">About Us </Link>
                            </li>
                            <li>
                              <Link to="/new-arrivals">Our Product </Link>
                            </li>
                            <li>
                              <Link to="/product-detail">Product details</Link>
                            </li>
                            <li>
                              <Link to="/cart">Cart </Link>
                            </li>
                            <li>
                              <Link to="/checkout"> Checkout </Link>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <Link to="/about-us">About Us </Link>
                          <ul>
                            <li>
                              <Link to="/login">Login </Link>
                            </li>
                            <li>
                              <Link to="/register">Register </Link>
                            </li>
                            <li>
                              <Link to="/faqs">Faq's </Link>
                            </li>
                            <li>
                              <Link to="/gift-coupon">Create Gift </Link>
                            </li>
                            <li>
                              <Link to="/privacy-policy">Privacy Policy </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      <div className="search-flyout">
        <div className="serach-container">
          <button
            className="sm-btn mb-3"
            id="search-cls"
            onClick={handleRemoveBodyClass}
          >
            close
          </button>
          <form>
            <input
              type="text"
              name="product-search"
              placeholder="Enter keywords"
              className="form-control"
            />
          </form>
          <div className="prd-result scroll-bar">
            <div className="row">
              <div className="col-lg-4 col-sm-4 col-xs-6">
                <div className="product">
                  <div className="product-img">
                    <a href="#">
                      <img
                        src="images/white-top.jpg"
                        alt="whiteshut"
                        className="prd-default-img"
                      />
                      <img
                        src="images/white-top-with-jacket.jpg"
                        alt=""
                        className="prd-hover-img"
                      />
                    </a>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#" tabIndex={0}>
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>$30</span> <del>$70</del>{" "}
                      <span className="tcolor">63% Off</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* repect */}
              <div className="col-lg-4 col-sm-4 col-xs-6">
                <div className="product">
                  <div className="product-img">
                    <a href="#">
                      <img
                        src="images/kasmiri.jpg"
                        alt="whiteshut"
                        className="prd-default-img"
                      />
                      <img
                        src="images/tranding.jpg"
                        alt=""
                        className="prd-hover-img"
                      />
                    </a>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#" tabIndex={0}>
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>$30</span> <del>$70</del>{" "}
                      <span className="tcolor">63% Off</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* repect */}
              <div className="col-lg-4 col-sm-4 col-xs-6">
                <div className="product">
                  <div className="product-img">
                    <a href="#">
                      <img
                        src="images/fitness.jpg"
                        alt="whiteshut"
                        className="prd-default-img"
                      />
                      <img
                        src="images/fitness-2.jpg"
                        alt=""
                        className="prd-hover-img"
                      />
                    </a>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#" tabIndex={0}>
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>$30</span> <del>$70</del>{" "}
                      <span className="tcolor">63% Off</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* repect */}
              <div className="col-lg-4 col-sm-4 col-xs-6">
                <div className="product">
                  <div className="product-img">
                    <a href="#">
                      <img
                        src="images/white-top.jpg"
                        alt="whiteshut"
                        className="prd-default-img"
                      />
                      <img
                        src="images/white-top-with-jacket.jpg"
                        alt=""
                        className="prd-hover-img"
                      />
                    </a>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#" tabIndex={0}>
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>$30</span> <del>$70</del>{" "}
                      <span className="tcolor">63% Off</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* repect */}
              <div className="col-lg-4 col-sm-4 col-xs-6">
                <div className="product">
                  <div className="product-img">
                    <a href="#">
                      <img
                        src="images/kasmiri.jpg"
                        alt="whiteshut"
                        className="prd-default-img"
                      />
                      <img
                        src="images/tranding.jpg"
                        alt=""
                        className="prd-hover-img"
                      />
                    </a>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#" tabIndex={0}>
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>$30</span> <del>$70</del>{" "}
                      <span className="tcolor">63% Off</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* repect */}
              <div className="col-lg-4 col-sm-4 col-xs-6">
                <div className="product">
                  <div className="product-img">
                    <a href="#">
                      <img
                        src="images/fitness.jpg"
                        alt="whiteshut"
                        className="prd-default-img"
                      />
                      <img
                        src="images/fitness-2.jpg"
                        alt=""
                        className="prd-hover-img"
                      />
                    </a>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#" tabIndex={0}>
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>$30</span> <del>$70</del>{" "}
                      <span className="tcolor">63% Off</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* repect */}
            </div>
          </div>
        </div>
      </div>
      {/* flyout search */}
      {/* header end */}
    </>
  );
};

export default Header;
